import { apiClient, bearer, unwrap } from './client';
import type { components } from './types';

export type ChecklistOut = components['schemas']['ChecklistOut'];
export type ChecklistItem = components['schemas']['ChecklistItem'];
export type OnboardingStats = components['schemas']['OnboardingStats'];

export function getPortalChecklist(
  engagementId: string,
  idToken: string,
): Promise<ChecklistOut> {
  return apiClient
    .GET('/api/portal/engagements/{engagement_id}/checklist', {
      params: { path: { engagement_id: engagementId } },
      headers: bearer(idToken),
    })
    .then(unwrap<ChecklistOut>);
}

/** Practitioner-side read — identical payload to the portal's. */
export function getEngagementChecklist(
  engagementId: string,
  idToken: string,
): Promise<ChecklistOut> {
  return apiClient
    .GET('/api/engagements/{engagement_id}/checklist', {
      params: { path: { engagement_id: engagementId } },
      headers: bearer(idToken),
    })
    .then(unwrap<ChecklistOut>);
}
